var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wp-checkbox d-flex align-center",class:{
    'wp-checkbox_active': _vm.state,
    'wp-checkbox_disabled': _vm.disabled,
    'wp-checkbox_solo': _vm.solo,
    'wp-checkbox_transparent': _vm.transparent,
  },attrs:{"name":_vm.name},on:{"click":_vm.change}},[_c('div',{staticClass:"wp-checkbox__title"},[_vm._v(_vm._s(_vm.title))]),_c('VCheckbox',{staticClass:"wp-checkbox__element",attrs:{"name":_vm.name,"disabled":_vm.disabled,"hide-details":""},on:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }